module.exports = __webpack_public_path__ + "static/media/default_avatar.fd0c5598.png";